<div *ngIf="notification" class="row notification">
  <div class="col-2 notification-icon">
    <div *ngIf="notification.state === notificationState.Processing" class="in-progress-spinner"></div>
    <i *ngIf="notification.state === notificationState.Failed" class="far fa-times-circle text-danger"></i>
    <i *ngIf="notification.state === notificationState.Queued" class="far fa-clock text-secondary"></i>
    <i *ngIf="notification.state === notificationState.Complete" class="far fa-check-circle text-success"></i>
    <i *ngIf="notification.state === notificationState.None" class="fas fa-info-circle text-info"></i>
  </div>
  <div class="col notification-text">
    <div>{{notification.description}}</div>
    <div>{{notification.message}}</div>
  </div>

  <p-overlayPanel [showTransitionOptions]="'0ms'" #op>
    <div class="action" *ngFor="let action of notification.actions" (click)="navigate(action.params, op)">
      {{action.text}}
    </div>
    <div class="action" (click)="removeNotification()">
      Dismiss
    </div>
  </p-overlayPanel>

  <div class="col-2 actions-icon">
    <button class="actions-btn" type="text" (click)="actionsToggle($event, op)">
      <i class="fas fa-ellipsis-v"></i></button>
  </div>
</div>